import { isEurope, getStateFromName } from '@benzinga/utils';

export const testPlacementSelection = (placements, geo, is_mobile) => {
  if (!geo) {
    geo = {
      country_code: 'US',
      region: 'Michigan',
    };
  }
  let results = {};
  for (var i = 0; i <= 1000; i++) {
    let placement = selectPlacement(placements, geo, is_mobile);
    if (!results[placement.id]) {
      results[placement.id] = {
        count: 1,
        placement: placement,
      };
    } else {
      results[placement.id]['count']++;
    }
  }
  console.log('PRIMARY PLACEMENT RESULTS: ', results);
};

export const selectCampaignTargets = (campaigns, geo, is_mobile, log = false) => {
  return {
    floating: selectTarget(campaigns.floating, geo, is_mobile, log),
    popup: selectTarget(campaigns.popup, geo, is_mobile, log),
    primary: selectTarget(campaigns.primary, geo, is_mobile, log),
    secondary: selectTarget(campaigns.secondary, geo, is_mobile, log),
  };
};

export const selectTarget = (target, geo, is_mobile, log) => {
  if (!target) {
    return null;
  }
  const placement = target.placements ? selectPlacement(target.placements, geo, is_mobile, log) : null;
  if (placement?.type === 'campaign') placement.campaign = target.campaigns[placement.id];
  if (log) console.log('SELECTED TARGET: ', target, geo, placement);
  return placement;
};

export const selectPlacement = (placements, geo, is_mobile, log = false) => {
  let targets = targetPlacements(placements, geo, is_mobile);

  if (log) console.log('TARGETS: ', targets);

  if (!targets.length) targets = placements;

  // Randomize matches based on multiplier
  return selectRandomPlacement(targets, log);
};

export const selectRandomPlacement = (placements, log = false) => {
  if (placements.length === 1) return placements[0];

  let total = 0;
  for (let i = 0; i < placements.length; i++) {
    let p = placements[i];
    total += p.multiplier ? Number(p.multiplier) : 1;
  }

  if (log) console.log('----- FOUND PLACEMENTS: ', total, placements);

  if (total) {
    let r = Math.random() * total;
    let index = 0;
    if (log) console.log('----- RAND: ', r);
    for (let i = 0; i < total; i++) {
      let p = placements[i];
      index += p.multiplier ? Number(p.multiplier) : 1;
      if (log) console.log('----- INDEX: ', i);
      if (p.type === 'widget') {
        return p;
      }
      if (r < index) {
        if (log) console.log('----- MATCH: ', r, index);
        return p;
      }
      if (log) console.log('----- NEXT: ', index);
    }
  }

  return placements[0];
};

export const targetPlacements = (placements, geo, is_mobile) => {
  let matches = [];

  if (is_mobile) {
    matches = matchDevice(placements, 'mobile');
    matches = matchGeoTarget(matches, geo);
  }

  if (!matches.length && !is_mobile) {
    matches = matchDevice(placements, 'desktop');
    matches = matchGeoTarget(matches, geo);
  }

  if (!matches.length) {
    matches = matchDevice(placements, 'all-devices');
    matches = matchGeoTarget(matches, geo);
  }

  return matches;
};

export const matchDevice = (placements, device_type) => {
  let matches = [];

  for (let i = 0; i < placements.length; i++) {
    let p = placements[i];
    if (p.devices === device_type || p.devices === 'all-devices') matches.push(p);
  }

  return matches;
};

export const matchGeoTarget = (placements, geo) => {
  let matches = [];

  if (!geo) {
    return [];
  }

  // Matches Geo Specific
  for (let i = 0; i < placements.length; i++) {
    let p = placements[i];
    let state = getStateFromName(geo.region);
    if (p.geo_target === 'FABRIC' && !['California', 'New York', 'Montana'].includes(geo.region)) {
      matches.push(p);
    }
    if (p.geo_target === 'FIGURE' && geo.country_code === 'US' && state) {
      if (
        [
          'AL',
          'AZ',
          'AR',
          'CA',
          'CO',
          'DE',
          'DC',
          'FL',
          'GA',
          'ID',
          'IN',
          'IA',
          'KS',
          'LA',
          'ME',
          'MA',
          'MI',
          'MN',
          'MO',
          'MT',
          'NE',
          'NV',
          'NH',
          'NJ',
          'NM',
          'ND',
          'OH',
          'OR',
          'RI',
          'SC',
          'SD',
          'TN',
          'UT',
          'VT',
          'WA',
          'WV',
          'WY',
        ].includes(state.abbreviation)
      ) {
        matches.push(p);
      }
    }
    if (p.geo_target === 'EMBRACE' && geo.country_code === 'US' && state) {
      if (!['WA'].includes(state.abbreviation)) {
        matches.push(p);
      }
    }
    if (p.geo_target === 'HSH' && geo.country_code === 'US' && state) {
      if (
        [
          'AK',
          'CO',
          'CT',
          'DE',
          'HI',
          'ID',
          'KS',
          'NE',
          'NH',
          'NJ',
          'NY',
          'NC',
          'OK',
          'RI',
          'SD',
          'VT',
          'WV',
          'WY',
        ].includes(state.abbreviation)
      ) {
        matches.push(p);
      }
    }
    if (p.geo_target === 'MORTY' && geo.country_code === 'US' && state) {
      if (
        [
          'AL',
          'AR',
          'CA',
          'CO',
          'CT',
          'DE',
          'FL',
          'GA',
          'ID',
          'IL',
          'IN',
          'IA',
          'KS',
          'KY',
          'ME',
          'MD',
          'MI',
          'MN',
          'MS',
          'NE',
          'NJ',
          'NM',
          'NY',
          'NC',
          'OH',
          'OK',
          'OR',
          'PA',
          'SC',
          'SD',
          'TN',
          'VA',
          'WA',
          'WV',
          'WI',
        ].includes(state.abbreviation)
      ) {
        matches.push(p);
      }
    }
    if (p.geo_target === 'BLOCKCHAIN' && geo.country_code === 'US' && state) {
      if (
        [
          'CA',
          'CO',
          'IL',
          'IN',
          'IA',
          'KY',
          'MD',
          'MA',
          'MI',
          'MN',
          'MO',
          'MT',
          'NE',
          'NH',
          'NM',
          'PA',
          'RI',
          'SC',
          'SD',
          'UT',
        ].includes(state.abbreviation)
      ) {
        matches.push(p);
      }
    }
    if (p.geo_target === 'LEMONADE' && geo.country_code === 'US' && state) {
      if (
        [
          'AZ',
          'CO',
          'CT',
          'DC',
          'GA',
          'IL',
          'IN',
          'IA',
          'MD',
          'MA',
          'MI',
          'MO',
          'NV',
          'NJ',
          'NY',
          'OH',
          'OK',
          "'OR",
          'PA',
          'RI',
          'TN',
          'TX',
          'VA',
          'WA',
          'WI',
        ].includes(state.abbreviation)
      ) {
        matches.push(p);
      }
    }
    if (
      p.geo_target === 'KRYPTOMAT' &&
      ['SI', 'EE', 'FR', 'NO', 'ES', 'PT', 'AT', 'GR', 'SK'].includes(geo.country_code) &&
      !['NG'].includes(geo.country_code)
    ) {
      matches.push(p);
    }
    if (p.geo_target === 'BUX' && ['NL', 'DE', 'BEL', 'FRA', 'AUT', 'IRL'].includes(geo.country_code)) {
      matches.push(p);
    }
    if (
      p.geo_target === 'ETX' &&
      [
        'AT',
        'LV',
        'PT',
        'FI',
        'BG',
        'LT',
        'RO',
        'DE',
        'HR',
        'LU',
        'SK',
        'GR',
        'CY',
        'MT',
        'SI',
        'HU',
        'NL',
        'ES',
        'IS',
        'DK',
        'NO',
        'SE',
        'IE',
        'EE',
        'PL',
        'GB',
        'ZA',
        'CZ',
      ].includes(geo.country_code)
    ) {
      matches.push(p);
    }
    if (
      p.geo_target === 'ZENGO' &&
      !['Hawaii', 'Connecticut', 'New Mexico', 'New York'].includes(geo.region) &&
      !['PAN', 'CUB'].includes(geo.country_code)
    ) {
      matches.push(p);
    }
    if (
      p.geo_target === 'HF' &&
      ![
        'US',
        'CA',
        'SD',
        'SY',
        'KP',
        'IR',
        'IQ',
        'MU',
        'MM',
        'YE',
        'AF',
        'VU',
        'AT',
        'BE',
        'BG',
        'HR',
        'CY',
        'CZ',
        'DK',
        'EE',
        'FI',
        'FR',
        'DE',
        'GR',
        'HU',
        'IE',
        'IT',
        'LV',
        'LT',
        'LU',
        'MT',
        'NL',
        'PL',
        'PT',
        'RO',
        'SK',
        'SI',
        'ES',
        'SE',
        'LI',
        'IS',
        'NO',
      ].includes(geo.country_code)
    ) {
      matches.push(p);
    }

    if (p.geo_target === 'LUXURY' && geo.country_code === 'US' && state) {
      if (
        [
          'DE',
          'ME',
          'OR',
          'CA',
          'CO',
          'CT',
          'DC',
          'FL',
          'GA',
          'IL',
          'MD',
          'MA',
          'MI',
          'NC',
          'NH',
          'OH',
          'NJ',
          'NY',
          'PA',
          'RI',
          'SC',
          'TN',
          'TX',
          'VA',
          'WA',
        ].includes(state.abbreviation)
      ) {
        matches.push(p);
      }
    }
    if (p.geo_target === 'DAYfFRWARD' && geo.country_code === 'US' && state) {
      if (['TX', 'UT'].includes(state.abbreviation)) {
        matches.push(p);
      }
    }
    if (p.geo_target === 'VOOM' && geo.country_code === 'US' && state) {
      if (['IN', 'AZ', 'OH', 'IL'].includes(state.abbreviation)) {
        matches.push(p);
      }
    }
    if (p.geo_target === 'B2Z' && geo.country_code === 'US' && state) {
      if (
        ['AZ', 'CO', 'GA', 'IL', 'IN', 'IA', 'MI', 'MN', 'MO', 'NV', 'NC', 'OR', 'TN', 'TX', 'VA', 'WI'].includes(
          state.abbreviation,
        )
      ) {
        matches.push(p);
      }
    }
    if (
      p.geo_target === 'EIGHTCAP_FOREX' &&
      ['GB', 'AU', 'CA', 'ES', 'DE', 'FR', 'IT', 'BE', 'NL', 'NO', 'DK', 'SE', 'PT', 'BR', 'MY'].includes(
        geo.country_code,
      )
    ) {
      matches.push(p);
    }
    if (
      p.geo_target === 'EIGHTCAP_CRYPTO' &&
      ['AU', 'CA', 'ES', 'DE', 'FR', 'IT', 'BE', 'NL', 'NO', 'DK', 'SE', 'PT', 'BR', 'MY'].includes(geo.country_code)
    ) {
      matches.push(p);
    }
    if (
      p.geo_target === 'IFC' &&
      ![
        'US',
        'JP',
        'RU',
        'NG',
        'ET',
        'EG',
        'CD',
        'TZ',
        'ZA',
        'KE',
        'UG',
        'DZ',
        'SD',
        'MA',
        'AO',
        'MZ',
        'GH',
        'MG',
        'CM',
        'NE',
        'BF',
        'ML',
        'MW',
        'ZM',
        'SN',
        'TD',
        'SO',
        'ZW',
        'GN',
        'RW',
        'BJ',
        'BI',
        'TN',
        'SS',
        'TG',
        'SL',
        'LY',
        'CG',
        'LR',
        'CF',
        'MR',
        'ER',
        'NA',
        'GM',
        'BW',
        'GA',
        'LS',
        'GW',
        'GQ',
        'MU',
        'DJ',
        'KM',
        'CV',
        'ST',
        'SC',
        'SZ',
      ].includes(geo.country_code)
    ) {
      matches.push(p);
    }
    if (p.geo_target === 'ETHOS' && geo.country_code === 'US' && state) {
      if (
        [
          'AL',
          'AK',
          'AZ',
          'AR',
          'CA',
          'CO',
          'CT',
          'DE',
          'FL',
          'GA',
          'HI',
          'ID',
          'IL',
          'IN',
          'IA',
          'KS',
          'KY',
          'LA',
          'ME',
          'MD',
          'MA',
          'MI',
          'MN',
          'MS',
          'MO',
          'MT',
          'NE',
          'NV',
          'NH',
          'NJ',
          'NM',
          'NC',
          'ND',
          'OH',
          'OK',
          'OR',
          'PA',
          'RI',
          'SC',
          'SD',
          'TN',
          'TX',
          'UT',
          'VT',
          'VA',
          'WA',
          'WV',
          'WI',
          'WY',
        ].includes(state.abbreviation)
      ) {
        matches.push(p);
      }
    }
    if (p.geo_target === 'COVER_RIGHT' && geo.country_code === 'US' && state) {
      if (
        ['NY', 'CA', 'AZ', 'FL', 'GA', 'NC', 'OH', 'PA', 'TX', 'IL', 'MO', 'TN', 'IN', 'SC', 'NJ', 'NV', 'VA'].includes(
          state.abbreviation,
        )
      ) {
        matches.push(p);
      }
    }

    if (
      p.geo_target === 'GO_MARKETS' &&
      [
        'AU',
        'AT',
        'DZ',
        'FR',
        'BH',
        'AD',
        'DE',
        'BR',
        'CO',
        'HK',
        'KH',
        'CY',
        'ID',
        'CR',
        'DO',
        'IE',
        'CZ',
        'IN',
        'MY',
        'EG',
        'JM',
        'MN',
        'GR',
        'KN',
        'NZ',
        'HU',
        'MA',
        'PH',
        'IT',
        'NG',
        'SA',
        'KW',
        'OM',
        'SG',
        'MU',
        'PE',
        'ES',
        'MX',
        'RO',
        'TH',
        'NO',
        'ZA',
        'AE',
        'PL',
        'LK',
        'GB',
        'PT',
        'ZM',
        'VN',
        'QA',
        'SK',
        'SI',
        'KR',
        'SE',
        'CH',
        'TW',
        'UA',
      ].includes(geo.country_code)
    ) {
      matches.push(p);
    }

    if (
      p.geo_target === 'PEPPERSTONE' &&
      [
        'AU',
        'UK',
        'BE',
        'BG',
        'CZ',
        'DK',
        'CY',
        'LV',
        'LT',
        'LU',
        'ES',
        'FR',
        'HR',
        'IT',
        'PL',
        'PT',
        'RO',
        'SI',
        'HU',
        'MT',
        'NL',
        'AT',
        'IS',
        'LI',
        'NO',
        'SK',
        'FI',
        'SE',
        'DE',
        'EE',
        'IE',
        'EL',
        'AE',
        'KE',
        'ZA',
        'NG',
        'BW',
        'PA',
        'CR',
        'MX',
        'KW',
      ].includes(geo.country_code)
    ) {
      matches.push(p);
    }
    if (
      p.geo_target === 'FREEDOM' &&
      [
        'AE',
        'TH',
        'SK',
        'SI',
        'SE',
        'RO',
        'QA',
        'PT',
        'PL',
        'NO',
        'NL',
        'MT',
        'LV',
        'LU',
        'LT',
        'LI',
        'IT',
        'IS',
        'IE',
        'AT',
        'BE',
        'BG',
        'CH',
        'CZ',
        'DE',
        'DK',
        'EE',
        'ES',
        'FI',
        'FR',
        'GB',
        'GR',
        'HR',
        'HU',
      ].includes(geo.country_code)
    ) {
      matches.push(p);
    }

    if (
      p.geo_target === 'DEGIRO' &&
      ['CZ', 'DK', 'DE', 'ES', 'GE', 'FR', 'IE', 'IT', 'NL', 'NO', 'PL', 'PT', 'FL', 'SE', 'CH', 'GB'].includes(
        geo.country_code,
      )
    ) {
      matches.push(p);
    }

    if (
      p.geo_target === 'PLUS500' &&
      [
        'AU',
        'AT',
        'BG',
        'CY',
        'DK',
        'FI',
        'DE',
        'GR',
        'HU',
        'IE',
        'IL',
        'IT',
        'LU',
        'MT',
        'NL',
        'NZ',
        'NO',
        'PL',
        'RO',
        'SK',
        'ZA',
        'SE',
        'GB',
      ].includes(geo.country_code)
    ) {
      matches.push(p);
    }

    if (p.geo_target === 'LEMONADE_HOME' && geo.country_code === 'US' && state) {
      if (['CO', 'CT', 'NY', 'TX'].includes(state.abbreviation)) {
        matches.push(p);
      }
    }

    if (p.geo_target === 'UPROAR_CAR' && geo.country_code === 'US' && state) {
      if (!['CA', 'FL', 'WI', 'MO'].includes(state.abbreviation)) {
        matches.push(p);
      }
    }

    if (p.geo_target === 'CAPCENTER' && geo.country_code === 'US' && state) {
      if (['VA', 'NC', 'SC', 'MD', 'WA', 'DC'].includes(state.abbreviation)) {
        matches.push(p);
      }
    }
    if (p.geo_target === 'LEMONADE_RENTERS' && geo.country_code === 'US' && state) {
      if (
        [
          'AZ',
          'AR',
          'CA',
          'CO',
          'CT',
          'DC',
          'FL',
          'GA',
          'IL',
          'IN',
          'IA',
          'MD',
          'MA',
          'MI',
          'MO',
          'NV',
          'NJ',
          'NM',
          'NY',
          'OH',
          'OK',
          'OR',
          'PA',
          'RI',
          'TN',
          'TX',
          'VA',
          'WA',
          'WI',
        ].includes(state.abbreviation)
      ) {
        matches.push(p);
      }
    }
    if (p.geo_target === 'UPLAND' && !['CU', 'SY', 'IR', 'KP'].includes(geo.country_code)) {
      matches.push(p);
    }
    if (
      p.geo_target === 'COINSMART' &&
      [
        'AT',
        'BE',
        'BR',
        'BG',
        'CA',
        'CY',
        'CZ',
        'DK',
        'EE',
        'FI',
        'FR',
        'GE',
        'DE',
        'GR',
        'HU',
        'IE',
        'IT',
        'LV',
        'LT',
        'LU',
        'MT',
        'MX',
        'NL',
        'PT',
        'RO',
        'SK',
        'SI',
        'ZA',
        'ES',
        'SE',
        'TR',
        'UA',
        'GB',
      ].includes(geo.country_code)
    ) {
      matches.push(p);
    }

    if (p.geo_target === 'UMA' && geo.country_code === 'US' && state) {
      if (
        [
          'AL',
          'AZ',
          'AR',
          'CO',
          'GA',
          'ID',
          'IL',
          'IN',
          'IA',
          'KS',
          'KY',
          'LA',
          'MD',
          'MI',
          'MS',
          'MT',
          'NE',
          'NV',
          'NJ',
          'NC',
          'ND',
          'OH',
          'OK',
          'PA',
          'SC',
          'SD',
          'TN',
          'TX',
          'VA',
          'WI',
          'WY',
        ].includes(state.abbreviation)
      ) {
        matches.push(p);
      }
    }
    if (
      p.geo_target === 'CENTERPOINT' &&
      ![
        'AF',
        'AL',
        'DZ',
        'AS',
        'AO',
        'AG',
        'AR',
        'AM',
        'AW',
        'AZ',
        'BH',
        'BD',
        'BB',
        'BY',
        'BZ',
        'BJ',
        'BM',
        'BT',
        'BO',
        'BA',
        'BW',
        'BR',
        'BG',
        'BF',
        'BI',
        'KH',
        'CM',
        'CA',
        'CF',
        'TD',
        'CN',
        'CO',
        'CU',
        'CW',
        'CY',
        'DJ',
        'DM',
        'DO',
        'EC',
        'EG',
        'SV',
        'ER',
        'EE',
        'ET',
        'FJ',
        'PF',
        'GA',
        'GM',
        'GE',
        'GH',
        'GD',
        'GT',
        'GN',
        'GY',
        'HT',
        'HN',
        'IN',
        'ID',
        'IR',
        'IQ',
        'CI',
        'JM',
        'JO',
        'KZ',
        'XK',
        'KE',
        'KI',
        'CR',
        'KW',
        'KG',
        'LA',
        'LV',
        'LB',
        'LR',
        'LY',
        'LI',
        'MK',
        'MG',
        'MW',
        'MY',
        'MV',
        'ML',
        'MT',
        'MR',
        'MH',
        'MU',
        'MX',
        'MC',
        'MN',
        'ME',
        'MA',
        'MZ',
        'MM',
        'KP',
        'NA',
        'NP',
        'NI',
        'NE',
        'NG',
        'OM',
        'PK',
        'PA',
        'PG',
        'PY',
        'PE',
        'PH',
        'QA',
        'RU',
        'RW',
        'SA',
        'SN',
        'RS',
        'SC',
        'SL',
        'SB',
        'SO',
        'SS',
        'LK',
        'SD',
        'SR',
        'SZ',
        'SY',
        'TJ',
        'TZ',
        'TH',
        'TG',
        'TT',
        'TN',
        'TM',
        'TV',
        'UG',
        'UA',
        'AE',
        'UY',
        'UZ',
        'VU',
        'VE',
        'YE',
        'ZM',
        'ZW',
        'BN',
        'BU',
        'MM',
        'CV',
        'CG',
        'CD',
        'HR',
        'VN',
        'CI',
      ].includes(geo.country_code)
    ) {
      matches.push(p);
    }

    if (p.geo_target === 'NASB' && geo.country_code === 'US' && state) {
      if (!['CT', 'DE', 'IL', 'LA', 'MA', 'MD', 'MS', 'NJ', 'NY', 'RI', 'TX'].includes(state.abbreviation)) {
        matches.push(p);
      }
    }
    if (
      p.geo_target === 'SWISSQUOTE' &&
      ['SA', 'JO', 'BH', 'CO', 'CL', 'PE', 'MX', 'UY', 'EC', 'CH', 'KW', 'GB', 'AE'].includes(geo.country_code)
    ) {
      matches.push(p);
    }
    if (p.geo_target === 'ANGEL_OAK' && geo.country_code === 'US' && state) {
      if (
        [
          'CO',
          'CT',
          'DE',
          'DC',
          'FL',
          'GA',
          'ID',
          'IL',
          'IN',
          'IA',
          'KS',
          'KY',
          'LA',
          'ME',
          'MD',
          'MI',
          'MN',
          'MS',
          'NV',
          'NH',
          'NM',
          'NC',
          'OH',
          'OK',
          'OR',
          'PA',
          'SC',
          'TN',
          'TX',
          'UT',
          'VA',
          'VT',
          'WA',
        ].includes(state.abbreviation)
      ) {
        matches.push(p);
      }
    }

    let geo_key = p.geo_target;
    let checkCmsGeo = geo_key.indexOf('geo_');
    if (checkCmsGeo === 0) {
      let country = p.country;
      let country_exclude = p.country_exclude;
      let state = p.states;
      let state_exclude = p.state_exclude;

      if (country_exclude && country && !country.includes(geo.country_code)) {
        matches.push(p);
      } else if (!country_exclude && country && country.includes(geo.country_code)) {
        matches.push(p);
      }

      if (geo.country_code === 'US' && state_exclude && state && !state.includes(geo.country_code)) {
        matches.push(p);
      } else if (geo.country_code === 'US' && !state_exclude && state && state.includes(geo.country_code)) {
        matches.push(p);
      }
    }
  }

  // Match to a country
  for (let i = 0; i < placements.length; i++) {
    let p = placements[i];
    if (p.geo_target) {
      // console.log(p.geo_target, '++++++++', geo.country_code);
      if (p.geo_target !== 'NON-US' && p.geo_target.split(',').includes(geo.country_code)) {
        matches.push(p);
      }
    }
  }

  // Match to non-US
  if (!matches.length) {
    for (let i = 0; i < placements.length; i++) {
      let p = placements[i];
      if (p.geo_target === 'NON-US' && geo.country_code !== 'US') {
        matches.push(p);
      }
    }
  }

  // // Match to Regions
  // if (!matches.length) {
  //   for(let i = 0; i < placements.length; i++) {
  //     let p = placements[i];
  //     if(p.geo_target === 'NON-US' && geo.country_code !== 'US') {
  //       matches.push(p)
  //     }
  //   }
  // }

  // Match to non-EU
  if (!matches.length) {
    for (let i = 0; i < placements.length; i++) {
      let p = placements[i];
      if (p.geo_target === 'NON-EU' && !isEurope(geo.country_code)) {
        matches.push(p);
      }
    }
  }

  // Match to EU
  if (!matches.length) {
    for (let i = 0; i < placements.length; i++) {
      let p = placements[i];
      if (p.geo_target === 'EU' && isEurope(geo.country_code)) {
        matches.push(p);
      }
    }
  }

  // Matches Globally
  if (!matches.length) {
    for (let i = 0; i < placements.length; i++) {
      let p = placements[i];
      if (p.geo_target === '' || p.geo_target === 'GLOBAL') {
        matches.push(p);
      }
    }
  }

  return matches;
};

export const filterByType = (placements, type) => {
  let matches = [];

  for (let i = 0; i < placements.length; i++) {
    let p = placements[i];
    if (p.type === type) matches.push(p);
  }

  return matches;
};
